import axios from 'axios';
import { awsUrl } from '../../axiosInstance';

export const OpenTextGet = () => {

    return axios.get(`${awsUrl}/v1/openText`, {
        headers: {
            'Authorization': `bearer ${localStorage.jwtToken}`,
        },
    })

}


export const OpenTextSet = (data) => {

    return axios.put(`${awsUrl}/v1/openText`,
        data, {
        headers: {
            'Authorization': `bearer ${localStorage.jwtToken}`,
        },
    })
}

export const addOpenText = (data) => {

    return axios.post(`${awsUrl}/v1/openText`,
        data, {
        headers: {
            'Authorization': `bearer ${localStorage.jwtToken}`,
        },
    })
}

export const deleteOpenText = (id) => {

    return axios.delete(`${awsUrl}/v1/openText/${id}`, {
        headers: {
            'Authorization': `bearer ${localStorage.jwtToken}`,
        },
    })
}